import React, { useEffect, useState } from "react";

import { Rate as AntRate } from "antd";

import { generateRandomId, useTranslation } from "utils";

import { RATING_STATUS } from "consts";

import { Icon, Tooltip } from "components";

const svgPath =
  '<path d="M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3" />';

/**
 *
 * @param type {(ARTICLE_NEWS.ARTICLE|ARTICLE_NEWS.NEWS)} ARTICLE_NEWS
 * @param initialValue {(RATING_STATUS.NONE| RATING_STATUS.LIKED|RATING_STATUS.DISLIKED)} RATING_STATUS
 * @param onChange
 * @param disabled {boolean}
 * @param iconSize
 * @param color
 * @returns {JSX.Element}
 * @constructor
 */
export const ContentRating = ({ type, initialValue, onChange, disabled, iconSize, color }) => {
  const { t } = useTranslation("global");
  const [animating, setAnimating] = useState(false);
  const [thumbsUpChecked, setThumbsUpChecked] = useState(initialValue === RATING_STATUS.LIKED);
  const [thumbsDownChecked, setThumbsDownChecked] = useState(initialValue === RATING_STATUS.DISLIKED);

  const thumbsUpId = generateRandomId();
  const thumbsDownId = generateRandomId();

  const addAnimation = (id) => {
    setAnimating(true);
    const icon = document.getElementById(id);

    const qty = Math.floor(Math.random() * 20) + 5;
    const group = [];

    const iconBurst = document.createElement("div");
    iconBurst.id = `${id}-siblings`;
    iconBurst.setAttribute("class", "icon-burst");
    iconBurst.style.top = `${icon.getBoundingClientRect().top + window.scrollY}px`;
    iconBurst.style.left = `${icon.getBoundingClientRect().left + window.scrollX}px`;
    document.body.appendChild(iconBurst);

    for (let i = 0; i < qty; i += 1) {
      const scale = Math.floor(Math.random() * 5) + 5;
      const x = Math.floor(Math.random() * 100) - 50;
      const y = Math.floor(Math.random() * 100) - 50;

      const newIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      newIcon.setAttribute("width", "24");
      newIcon.setAttribute("height", "24");
      newIcon.setAttribute("fill", color);
      newIcon.style.transform = `scale(0.${scale})`;
      newIcon.innerHTML = svgPath;

      document.getElementById(`${id}-siblings`).appendChild(newIcon);

      group.push({
        shape: newIcon,
        x: x,
        y: y,
      });
    }

    setTimeout(() => {
      for (let a = 0; a < group.length; a += 1) {
        const { shape } = group[a];
        const { x } = group[a];
        const { y } = group[a];

        shape.style.left = x;
        shape.style.top = y;
        shape.style.transform = "scale(0)";
      }
    }, 100);

    setTimeout(() => {
      document.getElementById(`${id}-siblings`).remove();
      setAnimating(false);
    }, 1000);
  };

  const handleChange = (v, type) => {
    if (disabled) {
      onChange();
      return;
    }
    const checked = v === 1;

    if (type === RATING_STATUS.LIKED) {
      if (checked) {
        addAnimation(thumbsUpId);
        onChange(RATING_STATUS.LIKED);
        return;
      }
      onChange(RATING_STATUS.NONE);
      return;
    }

    if (type === RATING_STATUS.DISLIKED) {
      if (checked) {
        // addAnimation(thumbsDownId);
        onChange(RATING_STATUS.DISLIKED);
        return;
      }
      onChange(RATING_STATUS.NONE);
    }
  };

  const handleInitialValue = (value) => {
    if (value === RATING_STATUS.LIKED) {
      setThumbsDownChecked(false);
      setThumbsUpChecked(true);
      return;
    }
    if (value === RATING_STATUS.DISLIKED) {
      setThumbsDownChecked(true);
      setThumbsUpChecked(false);
      return;
    }
    setThumbsDownChecked(false);
    setThumbsUpChecked(false);
  };

  useEffect(() => {
    handleInitialValue(initialValue);
  }, [initialValue]);

  return (
    <>
      <AntRate
        data-testid={`${type}-content-rating-thumb-up`}
        character={
          <Tooltip placement="bottom" title={t("like")}>
            <Icon
              iconName="tabler/thumb-up"
              fill={thumbsUpChecked ? color : "white"}
              color={color}
              className="icon margin-right-50"
              size={iconSize}
              id={thumbsUpId}
            />
          </Tooltip>
        }
        count={1}
        defaultValue={thumbsUpChecked ? 1 : 0}
        value={thumbsUpChecked || animating ? 1 : 0}
        onChange={(v) => handleChange(v, RATING_STATUS.LIKED)}
      />
      <AntRate
        data-testid={`${type}-content-rating-thumb-down`}
        character={
          <Tooltip placement="bottom" title={t("dislike")}>
            <Icon iconName="tabler/thumb-down" fill={thumbsDownChecked ? color : "white"} color={color} className="icon " size={iconSize} id={thumbsDownId} />
          </Tooltip>
        }
        count={1}
        defaultValue={thumbsDownChecked ? 1 : 0}
        value={thumbsDownChecked || animating ? 1 : 0}
        onChange={(v) => handleChange(v, RATING_STATUS.DISLIKED)}
      />
    </>
  );
};
